import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { hasRolePermissionsGuard } from '@guards/has-role-permissions.guard';
import { PlatformPage } from './platform/platform.component';

let moduleName = 'setting';

export const setting: Routes = [
  {
    path: `${moduleName}/platform/:tab`,
    component: PlatformPage,
    title: 'Configuraciones de la plataforma.',
    canActivate: [authGuard, hasRolePermissionsGuard(['GESTOR', 'COLABORADOR'], ['robots_sidea', 'provider_create'])],
  },
];
